// @flow

export const ColorTypeEnum = {
  black: 0,
  lightGrey: 1,
  grey: 2
};
